import { render, staticRenderFns } from "./generalTable.vue?vue&type=template&id=5617ae91&"
import script from "./generalTable.vue?vue&type=script&lang=js&"
export * from "./generalTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports